import React from "react";
import { IDSSLoader } from "../../building-blocks/DSSFramework";
import './index.scss';
export const Spinner = (props: IDSSLoader) =>
{
    return (
        <div className="spinner" data-testid={ props.dataTestId ?? props.id }>
            <div className='loader' style={ props.style || {} }></div>
            <div className=''>{ props.label }</div>
        </div>

    );
};